module.exports = {

  'QCPOS-001': '無此帳號，請至後台新增帳號密碼。',
  'QCPOS-002': '密碼錯誤，請確認您的登入資訊。'

};